import React from 'react';
import PropTypes from 'prop-types';
import './TabButton.css';

const TabButton = ({
  children,
  active = false,
  onClick,
  className = '',
  disabled = false,
  ...props
}) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={`tab-button ${active ? 'tab-button--active' : ''} ${disabled ? 'tab-button--disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

TabButton.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TabButton;